module.exports = __webpack_public_path__ + "img/eye-close.63ffe06a.svg";